import { BRAND } from '@/config/brand';
import { BrandMark } from './BrandMark';

export function Footer() {
  return (
    <footer className="mt-8 border-t border-line px-4 py-6 lg:px-8">
      <div className="flex flex-col items-start gap-4 text-xs text-muted sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <BrandMark size="sm" />
          <div className="hidden sm:block">
            <p className="text-content">{BRAND.name} Management System</p>
            <p className="text-subtle">v{BRAND.version}</p>
          </div>
        </div>
        <p className="text-subtle">
          Made with <span className="text-danger">♥</span> for Club Owners
        </p>
        <p className="flex items-center gap-1.5 text-subtle">
          <span className="h-1.5 w-1.5 rounded-full bg-success" /> Secure &amp; Reliable
        </p>
      </div>
    </footer>
  );
}
